import { SettingsLayout } from '../../../components/settings/SettingsLayout';
import { MembersAndInvites } from '../../../components/settings/MembersAndInvites';

function MembersSettingsPage() {
  return (
    <SettingsLayout>
      <MembersAndInvites />
    </SettingsLayout>
  );
}

export default MembersSettingsPage; 